import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { AbstractRender } from 'src/app/abstract/render.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsTextModel } from 'src/app/models/widgets/widgets-text.model';
import { CloneService } from '../clone/clone.service';

@Injectable({
  providedIn: 'root'
})
export class RenderTextService extends AbstractRender {
  constructor() {
    super();
  }

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
   render(
    widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean
  )
  {
    const text = widget as WidgetsTextModel;

    // Go up to custom model and overrides labels
    const labelOverrides: Map<string, string> = new Map<string, string>();
    CloneService.getLabelOverrides(
      widget,
      widgetRoot,
      labelOverrides
    );
    const overridedString = CloneService.overrideText(
      text.label,
      labelOverrides
    );

    let field = {
      className: 'primitive-text',
      template: overridedString
    };
    if (text.level === 0) {
      field.template = '<p class="prop-label">' + overridedString + '</p>';
    } else if (text.level > 0 && text.level < 7) {
      field.template =
          '<h' +
          text.level +
          '>' +
          overridedString +
          '</h' +
          text.level +
          '>';
    }
    if (text.template) {
      const textTemplate = JSON.parse(text.template);
      field = Object.assign({}, field, textTemplate);
    }
    config.push(field);
  }
}
